export default __webpack_public_path__ + "images/77b7b0abf927be8454b9af5cd9c170e6-facebook_logo@2x.png";